import { Num } from '@/helpers/Math.js'
import { Item } from '@/helpers/Item'

const state = {
  comboItemsList: false,
  selectedItemContainer: false,
  subItems: false,
  errorMessage: '',
  activeComboItems: {},
  setModifiersItem: [],
  orderIndex: 0,
  forCombo: 0, // set this to 0 initially
  selectedContainerLength: 0,
  modifingItem: false,
  additionalComboValue: 0,
  itemsModifiersValueTaxDiff: [],
  updateComboItems: [],
  setEditComboItem: [],
  itemIndexCounting: 0,
}

const actions = {
  findItemById({ state, rootGetters, commit }) {
    let items = []
    rootGetters.menu_items.forEach(item => {
      if (state.selectedItemContainer.for_items.includes(item._id)) {
        items.push(item)
      }
    })
    commit('SUB_ITEM_LIST', items)
  },
  setModifiers({ commit }, item) {
    return new Promise(resolve => {
      commit('SET_MODIFIERS', item)
      resolve()
    })
  },
  updateOrderIndex({ commit, state }) {
    let orderIndex = state.orderIndex
    if (orderIndex === 0) {
      orderIndex = parseInt(Item.getIndex(state)) + orderIndex
    }
    // eslint-disable-next-line no-console
    console.log(orderIndex, 'orderIndex', Item.getIndex(state))
    commit('SET_ORDER_INDEX', orderIndex)
  },
  reset({ commit }) {
    commit('RESET')
  },
  setAdditionalComboPrice({ commit, dispatch, getters }, items) {
    let price = getters.additionalComboPrice(items)
    dispatch('itemsModifierPrice', { items: items, combo_item: false })
    commit('ADDITIONAL_COMBO_VALUE', price)
  },
  itemsModifierPrice({ commit, state, rootGetters }, combo) {
    let orderIndexByCartItem = rootGetters.cart_items_count
    if (combo.combo_item) {
      orderIndexByCartItem = combo.combo_item.index
    }
    let itemId = state.comboItemsList._id || combo.combo_item._id
    let modifierPriceCollection = {
      itemId: itemId + orderIndexByCartItem,
      price: 0,
      net_price: 0,
      tax: 0,
    }
    combo.items.forEach(item => {
      if (rootGetters.hasModifiers(item)) {
        modifierPriceCollection.price += rootGetters.item_modifiers_price(item)
        modifierPriceCollection.net_price += rootGetters.item_modifiers_net_price(item)
         /*item.modifiers.forEach(modifier => {
           if (modifier.is_price) {
             // item_modifiers_price getter call

             modifierPriceCollection.price += modifier.value || 0
             modifierPriceCollection.tax += modifier.tax || 0
           }
        })*/
      }
    })
    commit('ITEMS_MODIFIERS_VALUE_TAX_DIFF', modifierPriceCollection)
  },
}

const getters = {
  getComboItem: state => (id = 0) => {
    if (id === 0) return state.setEditComboItem[id]
    if (state.setEditComboItem.length) {
      return state.setEditComboItem.find(item => item._id === id) || false
    }
    return false
  },
  getComboByForCombo: state => item => {
    if (state.setEditComboItem.length) {
      return (
        state.setEditComboItem.find(
          cmb_item => cmb_item.no === item.for_combo
        ) || false
      )
    }
    return false
  },
  getComboSubItemByForCombo: state => item => {
    if (state.updateComboItems.length) {
      return (
        state.updateComboItems.filter(
          cmb_sub_item => cmb_sub_item.for_combo === item.no
        ) || []
      )
    }
  },
  additionalComboPrice: () => items => {
    let price = 0
    items.forEach(item => {
      price += item.additional_combo_value || 0
    })
    return price
  },
  activeComboItem: state => (id = 0) => {
    return state.comboItemsList
      ? state.comboItemsList
      : getters.getComboItem[id]
  },
  totalItemQty: (state, getters) => {
    let qty = 0
    let activeComboItem = getters.activeComboItem(0)
    if (activeComboItem) {
      activeComboItem.combo_items.forEach(itemGrp => {
        qty += parseInt(itemGrp.qty)
      })
    }
    return qty
  },
  comboItemName: state => {
    if (state.comboItemsList) {
      return state.comboItemsList.name
    }
    return ''
  },
  limitOfSelectingItems: state => {
    if (state.selectedItemContainer) {
      return state.selectedItemContainer.qty
    }
    return 1
  },
  getItemPrice: (state, getters, rootState) => item => {
    let priceAvailability = item.price_availability
    let currentStore = rootState.context_store.current_store
    console.log(currentStore, 'currentStore')
    let price = priceAvailability.stores.find(
      store => store.param === currentStore._id
    )
    //If item price not found in stores, then check in countries
    if (!price) {
      price = priceAvailability.countries.find(
        store => store.param === currentStore.country
      )
    }
    //TODO: Find item price from city as wells
    return price ? price.value : 0
  },
  setItemPrice: (state, getters) => addedItem => {
    let itemPrice = 0
    let activeComboItem = getters.activeComboItem(0)
    activeComboItem.combo_items.forEach(item => {
      if (item.for_items.includes(addedItem._id)) {
        let itemTotalPrice = getters.getItemPrice(item)
        /*getters.fixDecimalValue({
          itemTotalPrice: itemTotalPrice,
          item: item,
        })*/
        itemPrice = parseInt(itemTotalPrice) / item.qty
      }
    })
    return itemPrice
  },
  priceSettlement: (state, getters) => activeItemModifiers => {
    let subItemNetPrice = 0
    let subItemTax = 0
    let pickItemPriceSettlement = false
    activeItemModifiers.forEach(item => {
      subItemNetPrice += item.netPrice
      subItemTax += item.tax
      pickItemPriceSettlement = item
    })
    let activeComboItem = state.comboItemsList
    let setMainItem = getters.updateItemPriceTax(activeComboItem)
    if (Num.round(subItemNetPrice) < setMainItem.netPrice) {
      activeItemModifiers.splice(
        activeItemModifiers.indexOf(pickItemPriceSettlement),
        1
      )
      // here we are checking if combo item price is 100 and there are 3 items only.
      // we need to set all three item price and tax according to 100
      // so we will update remaining amount .1 to ast item
      let differencePrice = setMainItem.netPrice - subItemNetPrice
      let differenceTax = setMainItem.tax - subItemTax
      pickItemPriceSettlement.netPrice = Num.round(
        pickItemPriceSettlement.netPrice + differencePrice
      )
      pickItemPriceSettlement.tax = Num.round(
        pickItemPriceSettlement.tax + differenceTax
      )
      /*if (subItemTax < setMainItem.tax) {
        pickItemforPriceSettelment.tax = Num.round(
            pickItemforPriceSettelment.tax + differenceTax
        )
      } else {
        pickItemforPriceSettelment.tax = Num.round(
          pickItemforPriceSettelment.tax - differenceTax
        )
      }*/
      activeItemModifiers.push(pickItemPriceSettlement)
    }
    return activeItemModifiers
  },
  updateItemPriceTax: (state, getters) => item => {
    let isCombo = item.item_type === 'combo_item'
    if (!isCombo) {
      let qty = 1
      if (state.comboItemsList) {
        qty = item.quantity || 1
        item.index = state.orderIndex
        item.for_combo =
          state.forCombo ||
          (state.comboItemsList.index
            ? state.comboItemsList.index
            : 0)
        item.tax_sum = state.comboItemsList.tax_sum
      } else {
        qty = item.quantity
      }
      let itemPrice =
        parseFloat(getters.setItemPrice(item)) + item.additional_combo_value ||
        0
      item.value = itemPrice * qty
      item.netPrice = Item.itemNetPrice(item)
      item.tax = Item.itemTax(item)
      item.originalValue = item.value
    } else {
      item.value = item.value + state.additionalComboValue
      item.for_combo = false
      // state.itemsModifiersValueTaxDiff.price // need to update first item collection and add modifiers data
    }
    // item.grossPrice = rootGetters['order/grossPrice'](item)
    // item.netPrice = rootGetters['order/netPrice'](item)
    // item.tax = Num.round(item.grossPrice - item.netPrice)
    item = Item.prepare(state, { ...item })

    return item
  },
}

const mutations = {
  SET_COMBO_ITEMS: (state, comboItems) => {
    state.comboItemsList = comboItems
  },
  SET_SELECTED_ITEM_DATA: (state, selectedItemContainer) => {
    state.selectedItemContainer = selectedItemContainer
  },
  SUB_ITEM_LIST: (state, subItems) => {
    state.subItems = subItems
  },
  SET_ERROR_MESSAGE: (state, errorMessage) => {
    state.errorMessage = errorMessage
  },
  ACTIVE_COMBO_ITEMS: (state, activeComboItems) => {
    state.activeComboItems = activeComboItems
  },
  SET_MODIFIERS: (state, setModifiersItem) => {
    if (!setModifiersItem) {
      state.setModifiersItem = []
    } else {
      state.setModifiersItem.push(setModifiersItem)
    }
  },
  SET_ORDER_INDEX: (state, orderIndex) => {
    state.orderIndex = orderIndex + 1
  },
  SET_FOR_COMBO: (state, comboItemIndex) => {
    state.forCombo = comboItemIndex
  },
  RESET: (state) => {
    state.comboItemsList = false
    state.selectedItemContainer = false
    state.subItems = false
    state.errorMessage = ''
    state.activeComboItems = {}
    state.setModifiersItem = []
    state.orderIndex = 0
    state.forCombo = 0
    state.selectedContainerLength = 0
    state.modifingItem = false
    state.itemIndexCounting += state.updateComboItems.length
    state.updateComboItems = []
    state.additionalComboValue = 0
    // state.itemsModifiersValueTaxDiff = []
  },
  CONTAINER_SELECTED_LENGTH: (state, selectedContainerLength) => {
    state.selectedContainerLength = selectedContainerLength
  },
  ITEM_INDEX_COUNT: (state, itemIndexCounting) => {
    state.itemIndexCounting = itemIndexCounting
  },
  MODIFING_SELECTED_ITEM: (state, modifingItem) => {
    state.modifingItem = modifingItem
  },
  ADDITIONAL_COMBO_VALUE: (state, additionalComboValue) => {
    state.additionalComboValue = additionalComboValue
  },
  UPDATE_COMBO_ITEMS: (state, item) => {
    state.updateComboItems.push(item)
    // eslint-disable-next-line no-console
    console.log(state.updateComboItems, 'state.updateComboItems')
  },
  SET_EDIT_COMBO_ITEM: (state, item) => {
    state.setEditComboItem.push(item)
    // eslint-disable-next-line no-console
    console.log(state.setEditComboItem, 'setEditComboItem')
  },
  ITEMS_MODIFIERS_VALUE_TAX_DIFF: (state, modifier) => {
    if (!modifier) {
      state.itemsModifiersValueTaxDiff = []
      state.updateComboItems = []
      state.setEditComboItem = []
      state.additionalComboValue = 0
    } else {
      state.itemsModifiersValueTaxDiff.push(modifier)
    }
    // eslint-disable-next-line no-console
    console.log(state.itemsModifiersValueTaxDiff, 'modifiermodifier', modifier)
  },
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
}
